import React from 'react';
import AppHeader from './AppHeader';
import BottomTabBar from './BottomTabBar';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <AppHeader />
      <main className="flex-1 pb-[68px] pt-14 overflow-y-auto">
        <div className="max-w-screen-2xl mx-auto px-3 py-3">
          {children}
        </div>
      </main>
      <BottomTabBar />
    </div>
  );
}